module.exports = __webpack_public_path__ + "seal-duotone.svg?740f32578d2994c00a21c1752d0549b7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/seal-duotone.svg
// module id = 509
// module chunks = 2